// src/components/tiptap/floatingMenu/FloatingPromptInput.tsx
import { Box, HStack, Input } from "@chakra-ui/react"
import { FaWandMagicSparkles } from "react-icons/fa6"
import { useState } from "react"

export function FloatingPromptInput({
    onPromptSubmit,
  }: {
    onPromptSubmit: (prompt: string) => void
  }) {
    const [inputValue, setInputValue] = useState("")
  
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter" && inputValue.trim()) {
        onPromptSubmit(inputValue.trim())
        setInputValue("")
      }
    }
  
    return (
      <Box
        px={2}
        py={1}
        bg="white"
        border="1px solid"
        borderColor="gray.200"
        borderRadius="md"
        boxShadow="sm"
        mb={2}
        minWidth="360px" // ✅ longer than the menu
      >
        <HStack gap={2}>
          <FaWandMagicSparkles size={14} color="#f97316" />
          <Input
            size="xs"
            variant="outline"
            fontSize="sm"
            placeholder={`AI에게 아무 글이나 써보라고 요청하세요.`}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </HStack>
      </Box>
    )
  }
  